import Bullets from '@atoms/Bullets/Bullets';
import Button from '@atoms/Button/Button';
import Image from '@atoms/Image/Image';
import { IFeaturedArticleCard } from '@models/IFeaturedArticleCard';

const FeaturedArticleCard = ({
  title,
  readMoreLabel,
  image,
  url,
  readTime,
  articleInfo,
  dataTestId = 'Featured-Article-Card',
  epiEdit,
}: IFeaturedArticleCard) => {
  const { author, publishedDate, genre } = articleInfo ?? {};
  const [firstGenre] = genre ?? [];
  const bulletsArray = [firstGenre, publishedDate, author];

  return (
    <div
      className="flex h-full w-full flex-col items-center justify-around gap-5 rounded-[10px] bg-grey-200 px-2.5 pt-2.5 pb-13 text-black-100 lg:px-5 lg:pt-5 lg:pb-10 dark:bg-grey-600 dark:text-white"
      data-testid={dataTestId}
      data-epi-property-name={epiEdit}
    >
      <div className="relative flex-start">
        <p className="body-four absolute top-2.5 left-2.5 items-center justify-center rounded-[50px] bg-black-100 bg-opacity-50 px-4 py-1 lg:flex">
          {readTime}
        </p>
        <Image image={image} imageClasses="rounded-[10px]" />
      </div>
      <div className="flex flex-col items-center justify-center lg:w-4/5">
        <Bullets
          bullets={bulletsArray}
          textSize="body-two"
          dataTestId="Article-Card-Info-Bullets"
          className="mb-2.5 justify-center"
        />
        <p className="h3 mb-5 text-center lg:mb-7.5">{title}</p>
        <Button link={{ url, name: readMoreLabel }} className="text-center" />
      </div>
    </div>
  );
};

export default FeaturedArticleCard;
